import styled from "styled-components";
import {baseTheme} from "../../baseTheme";

const ConfirmPopupWrap = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 530;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(1,1,1, .2);
  padding: 24px 16px;
`

const ConfirmPopupSuccessBody = styled.div`
  background: #FFFFFF;
  box-shadow: 0px 0px 16px rgba(105, 112, 119, 0.12), 0px 8px 16px rgba(105, 112, 119, 0.16);
  border-radius: 8px;
  width: 100%;
  max-width: 660px;
  min-height: 197px;
  display: flex;
  align-items: center;
  padding: 48px;
  flex-direction: column;
  position: relative;
  
  .btnList {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .close {
    position: absolute;
    right: 25px;
    top: 25px;
    width: 24px;
    height: 24px;
    object-fit: contain;
    cursor: pointer;
  }
  
  h2 {
    font-style: normal;
    font-weight: 600;
    font-size: 28px;
    line-height: 36px;
    letter-spacing: -0.01em;
    text-align: center;
    color: #111111;
    margin-bottom: 32px;
    background-color: transparent;
    width: 100%;
  }

  @media ${baseTheme.media.large} {
    padding: 24px;
    
    .close {
      top: 24px;
      right: 24px;
    }
  }

  @media ${baseTheme.media.medium} {
    padding: 16px;
    min-height: auto;

    .close {
      top: 16px;
      right: 16px;
    }

    h2 {
      font-size: ${baseTheme.fz.titlePopupSmall};
      line-height: ${baseTheme.lh.titlePopupSmall};
      margin-bottom: 24px;
      padding: 0 24px;
    }
  }
`

const ConfirmPopupBtn =styled.button`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #4F7FFF;
  background: transparent;
  border: 1px solid #DDE1E6;
  border-radius: 6px;
  cursor: pointer;
  padding: 14px 20px;
  width: 100%;

  &.yes {
    color: #FFFFFF;
    background-color: #DA1E28;
  }

  &.margin {
    margin-left: 30px;
  }

  @media ${baseTheme.media.medium} {
    font-size: 14px;
    line-height: 18px;
    padding: 10px 14px;

    &.margin {
      margin-left: 16px;
    }
  }
`
export {ConfirmPopupWrap, ConfirmPopupSuccessBody, ConfirmPopupBtn}
